"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentReferenceContext = void 0;
/**
 * A reference to a document of any kind for any purpose. Provides metadata about the document so that the document can be discovered and managed. The scope of a document is any seralized object with a mime-type, so includes formal patient centric documents (CDA), cliical notes, scanned paper, and non-patient specific documents like policy text.
 */
var DocumentReferenceContext = /** @class */ (function () {
    function DocumentReferenceContext() {
    }
    return DocumentReferenceContext;
}());
exports.DocumentReferenceContext = DocumentReferenceContext;
